import {Component, Input, OnInit} from '@angular/core';
import {Column} from "../../models/column";


@Component({
  selector: 'app-table-loader',
  templateUrl: './table-loader.component.html',
  styleUrls: ['./table-loader.component.scss']
})
export class TableLoaderComponent implements OnInit {
  @Input() length: number = 5;
  @Input() dataSets: Array<Column>;

  columns = []

  ngOnInit(): void {
    for (let i = 1; i <= 10; i++) {
      this.columns.push(i)
    }
  }
}
